<template>
  <div class="first-screen" data-position="1" data-name="头图">
    <video
      class="fs-bg-video"
      muted
      autoplay
      loop
      src="https://www-cdn.djiits.com/reactor/assets/_next/static/videos/15430b20-0695-4795-9259-1054619111f7.mp4"
    ></video>
    <div class="fs-content">
      <img class="wd280" :src="$IMAGE_HOST + originOS6" alt="originOS6" />
      <div
        @click="playVideo"
        class="umx-video-button"
        data-video="https://www-res.flyme.cn/resources/flyme12/assets/tvc-40bc37ac.mp4"
        data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|044|002',module:'头图',button_name:'头图视频'}}"
      >
        观看视频
      </div>
    </div>
  </div>
</template>

<script>
import { initExposureTrack } from "@/utils/track.js";
import originOS6 from "@/assets/originOS6-white.svg";

export default {
  name: "FirstScreenVideo",
  data() {
    return {
      originOS6
    };
  },
  mounted() {
    initExposureTrack(".first-screen")();
  },
  methods: {
    playVideo() {
      const videoUrl = document
        .querySelector(".umx-video-button")
        .getAttribute("data-video");
      const bgVideo = this.$el.querySelector('.fs-bg-video')
      try {
        bgVideo.pause()
        new Video({
          mount: "#J_video",
          url: videoUrl,
          post: "",
          closeCallback: ()=>{
            document.body.style.height = 'auto'
            bgVideo.play().then().catch(err=>{console.error(err)})
          }
        });
        $(".video-js-outer-popup").addClass("black");
        document.body.style.height = '100vh'
      } catch (e) {
        throw Error(e, "播放失败");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.isPC.vp-head-fixed-flag {
  .first-screen {
    padding-top: 86px;
    height: calc(45.83333vw + 86px) !important;
  }
}
.first-screen {
  overflow: hidden;
  font-size: 0;
  height: 880 * $px1920vw + vw; // 固定header
  width: 100%;
  display: flow-root;
  background-size: 100% auto;
  position: relative;
  .fs-bg-video {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    left: 0;
    top: 0;
  }
  .fs-content {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .wd280 {
      width: 450 * $px1920vw + vw;
      margin-bottom: 48.3 * $px1920vw + vw;
    }
    .umx-video-button {
      width: 142 * $px1920vw + vw;
      height: 38 * $px1920vw + vw;
      border-radius: 20 * $px1920vw + vw;
      border: 1 * $px1920vw + vw solid #fff;
      display: flex;
      align-items: center;
      position: relative;
      font-size: 18 * $px1920vw + vw;
      line-height: 25.2 * $px1920vw + vw;
      padding: 0 24 * $px1920vw + vw;
      color: #fff;
      cursor: pointer;
      &::after {
        position: absolute;
        content: '';
        width: 0;
        height: 0;
        right: 24 * $px1920vw + vw;
        border-top: 6.5 * $px1920vw + vw solid transparent;    /* 控制三角形高度 */
        border-bottom: 6.5 * $px1920vw + vw solid transparent; /* 控制三角形高度 */
        border-left: 11 * $px1920vw + vw solid #fff;  
      }
    }
  }
}
</style>
